import type {
	TileCoordinates,
	UpgradeParams,
	UpgradeRewardValue,
} from "@/types/tile";
import { randomInteger } from "@/utils/number";
import { FrameName } from "../config";
import type { ResourceType } from "../config/resources";
import type { TileEntityWithOnUpgradeMethod } from "../TileEntity";
import TileEntity from "../TileEntity";

abstract class AbstractSalvageableTileEntity
	extends TileEntity
	implements TileEntityWithOnUpgradeMethod
{
	public static readonly frameName: FrameName;

	public get upgrades(): Map<FrameName, UpgradeParams> {
		if (this.cachedUpgrades) return this.cachedUpgrades;

		if (!this.config.upgrades?.get(FrameName.NOT_SET))
			return (this.cachedUpgrades = new Map<FrameName, UpgradeParams>(
				this.config.upgrades,
			));

		const rewardNotSet = {} as Partial<
			Record<ResourceType, UpgradeRewardValue>
		>;
		if ((this.config.rewardRange?.size ?? 0) > 0) {
			// for each rewardRange resource type, add an upgrade to the tile entity config of NOT_SET
			this.config.rewardRange?.forEach(
				(
					rewardRange: { min: number; max: number },
					resourceType: ResourceType,
				) => {
					rewardNotSet[resourceType] = randomInteger(
						rewardRange.min,
						rewardRange.max,
					);
				},
			);
		}

		const upgrades = new Map<FrameName, UpgradeParams>(super.upgrades);
		upgrades?.set(FrameName.NOT_SET, {
			price:
				this.config.upgrades?.get(FrameName.NOT_SET)?.price ??
				new Map<ResourceType, number>(),
			reward: rewardNotSet as Record<ResourceType, UpgradeRewardValue>,
		} as UpgradeParams);

		return (this.cachedUpgrades = upgrades);
	}

	public onUpgrade(upgradedTile: TileCoordinates): void {
		if (!this.config.onUpgrade) return;
		this.config.onUpgrade(upgradedTile);

		// eslint-disable-next-line no-console
		console.log("[salvageable] onUpgrade");
	}
}

export default AbstractSalvageableTileEntity;
